export default __webpack_public_path__ + "static/article-how-your-car-can-save-you-money-45cfca3b51e6c07e4fbdbfac34b0df23.jpg";